<template>
  <ResizableTable
    style="line-height: undet"
    sticky-headers
    :use-scroll="false"
    :min-height="0"
    @resize-done="columnWidths = $event"
  >
    <table class="w-full item-list-table">
      <thead>
        <tr>
          <td
            v-for="column in columns"
            :key="column.key"
            class="sticky"
            :class="column.class"
            :style="columnStyle(column)"
            :data-initial-width="column.width"
            :align="column.align"
          >
            <div class="flex items-center">
              <span class="min-w-0 flex-1 text-ellipsis">
                {{ column.name }}
              </span>
            </div>
          </td>
        </tr>
      </thead>
      <!-- <tbody> -->
      <MultipleFormItem v-model="attributes" as-table :can-add="false">
        <template
          v-slot="{ item, remove, add, isLastItem, isFirstItem, update }"
        >
          <AttributeItem
            :key="item.guid"
            :item="item"
            :remove="remove"
            :update="update"
            :disabled="disabled"
            :column="availableColumns.find((a) => a.key === item.key)"
          />
        </template>
      </MultipleFormItem>
    </table>
  </ResizableTable>
</template>

<script>
import MultipleFormItem from '@components/multiple-form-item'
import Pick from 'lodash/pick'
import ResizableTable from '@components/table/resizable-table'
import AttributeItem from './attribute-item'
export default {
  name: 'SelectedBaselineAttributeList',
  components: { ResizableTable, MultipleFormItem, AttributeItem },
  model: {
    event: 'change',
  },
  props: {
    availableColumns: { type: [Array, Object], required: true },
    value: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: { type: Boolean, default: false },
  },
  data() {
    this.columns = [
      { name: `${this.$tc('attribute')} ${this.$tc('name')}`, key: 'name' },
      { name: `${this.$tc('value')}`, key: 'value' },
      ...(!this.disabled
        ? [
            {
              name: `${this.$tc('action')}`,
              key: 'action',
              width: '100px',
            },
          ]
        : []),
    ]
    return {}
  },
  computed: {
    itemToDisplay() {
      return (this.items || []).map((i) => ({
        ...i,
      }))
    },
    attributes: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('change', value)
      },
    },
  },
  methods: {
    columnStyle(column) {
      return Pick(column, ['width', 'minWidth'])
    },
  },
}
</script>
